/** Copy of the stock page (Operations), ported from VentaHub. */
export const stock = {
  title: 'Get stock',
  description: 'What is on hand per SKU in a warehouse, and what it cost to land.',
  chooseTitle: 'Choose a warehouse',
  chooseHint: 'Stock is shown one warehouse at a time.',
  empty: 'No stock to report',
  emptyHint: 'Nothing matches these filters in this warehouse.',
  download: 'Download stock',
  filters: {
    warehouse: 'Warehouse',
    choose: 'Choose…',
    skus: 'SKU codes',
    name: 'SKU name',
    brand: 'Brand',
    vendor: 'Vendor',
    retailer: 'Retailer',
    retailerSkus: 'Retailer SKUs',
    allotted: 'Include allotted boxes',
    netBlocked: 'Take blocked out of available',
  },
  columns: {
    sku: 'SKU',
    retailerSku: 'Retailer SKU',
    name: 'Name',
    brand: 'Brand',
    category: 'Category',
    boxQty: 'Box qty',
    blocked: 'Blocked',
    available: 'Available',
    purchase: 'Purchase',
    shipping: 'Shipping',
    additional: 'Additional',
  },
} as const
